module.exports = __webpack_public_path__ + "img/lasource-30.539f0975.jpg";